export enum NumerationResetType {
    YEAR = 'YEAR',
    MONTH = 'MONTH',
    DAY = 'DAY'
}
